<template>
  <div class="club-list-container">
    <!-- 页面主体 (默认显示) -->
    <div class="container">
      <!-- 顶部区域：标题 -->
      <div class="header">
        <div class="title">{{ title }}</div>
      </div>

      <!-- 球杆列表 -->
      <div v-if="benefitsItemList.length > 0" class="card-list">
        <el-row :gutter="20">
          <!-- 循环渲染每一个球杆卡片 -->
          <el-col
              v-for="club in benefitsItemList"
              :key="club.id"
              :span="8"
              :xs="24"
              :sm="12"
              class="card-container"
          >
            <el-card
                shadow="hover"
                class="club-card"
                :class="{ 'is-selected': selectedCardId === club.id }"
                @click.native="handleCardSelect(club.id)"
            >
              <div v-if="selectedCardId === club.id" class="checkmark-container">
                <i class="el-icon-check"></i>
              </div>
              <!-- 卡片主体内容 -->
              <div class="card-body">
                <div class="info-item">
                  <span class="label">名称:</span>
                  <span class="value">{{ club.name }}</span>
                </div>
                <div class="info-item" v-if="club.equityIntro">
                  <span class="label">权益:</span>
                  <span class="value" style="color: #ea9538">{{ club.equityIntro }}</span>
                </div>
                <div class="info-item">
                  <span class="label">换补差:</span>
                  <span class="value">{{ club.supplement }}</span>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>

        <!-- 关键新增：表单区域 -->
        <div class="form-container">
          <el-form
              :model="form"
              :rules="rules"
              ref="formRef"
              label-width="100px"
              class="club-form"
          >
            <el-row :gutter="20">
              <!-- 球杆编号 (禁用，自动填充) -->
              <el-col :span="24" :sm="12">
                <el-form-item label="球杆编号" prop="oldNumber">
                  <el-input
                      v-model="form.oldNumber"
                      placeholder="球杆编号"
                      readonly
                  ></el-input>
                </el-form-item>
              </el-col>

              <!-- 球杆品牌 (禁用，自动填充) -->
              <el-col :span="24" :sm="12">
                <el-form-item label="球杆品牌" prop="oldBrand">
                  <el-input
                      v-model="form.oldBrand"
                      placeholder="球杆品牌"
                      readonly
                  ></el-input>
                </el-form-item>
              </el-col>
              <!-- 球杆型号 (禁用，自动填充) -->
              <el-col :span="24" :sm="12">
                <el-form-item label="球杆型号" prop="oldModel">
                  <el-input
                      v-model="form.oldModel"
                      placeholder="球杆型号"
                      readonly
                  ></el-input>
                </el-form-item>
              </el-col>

              <!-- 联系电话 -->
              <el-col :span="24" :sm="12">
                <el-form-item label="联系电话" prop="phonenumber">
                  <el-input
                      v-model="form.phonenumber"
                      placeholder="请输入联系电话"
                      maxlength="11"
                  ></el-input>
                </el-form-item>
              </el-col>

              <!-- 通讯地址 -->
              <el-col :span="24">
                <el-form-item label="通讯地址" prop="address">
                  <el-input
                      v-model="form.address"
                      placeholder="请输入详细通讯地址"
                      type="textarea"
                      :rows="2"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="24">
                <el-form-item label="旧杆图片" prop="proof">
                  <el-upload
                      class="avatar-uploader"
                      action="#"
                      accept="image/*"
                      :capture="captureType"
                      :on-change="(file, fileList) => handleFileChange(file, fileList)"
                      :file-list="form.fileList"
                      list-type="picture-card"
                      :on-preview="(file) => handlePreview(file)"
                      :on-remove="(file, fileList) => handleRemove(file, fileList)"
                      :limit="3"
                      :on-exceed="() => handleExceed()"
                      multiple
                      :auto-upload="false"
                  >
                    <i class="el-icon-plus" />
                  </el-upload>
                  <div class="upload-tip">最多上传3张图片，支持jpg/png格式，可多选</div>
                  <!-- 图片预览弹窗 -->
                  <el-dialog :visible.sync="dialogVisible" title="图片预览" width="90%" append-to-body>
                    <img
                        :src="dialogImageUrl"
                        alt="预览图"
                        style="width: 100%; max-height: 80vh; object-fit: contain;"
                        @error="handleImageError"
                    />
                    <div v-if="!dialogImageUrl" class="preview-empty">暂无预览图片</div>
                  </el-dialog>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>

      <div v-else class="empty-state">
        <el-empty description="暂无球杆权益信息"></el-empty>
      </div>

      <div class="btn-group">
        <el-button :disabled="submitDisabled"
            type="primary"
            @click="submitSelection"
        >
          提交申请
        </el-button>
      </div>
      <div class="btn-group-back">
        <el-button type="default" @click="goHome">返回</el-button>
      </div>

      <!-- 页脚 -->
      <el-footer class="footer">
        <p>JING-DIAN BILLIARD CLUB AFTER SALES</p>
      </el-footer>
    </div>
    <!-- 调用提示语弹框组件 -->
    <MessageDialog
        v-if="showDialog"
        :title="dialogTitle"
        :content="messageContent"
        :confirmText="confirmText"
        :showCancel="showCancel"
        @confirm="handleDialogConfirm"
        @cancel="handleCancel"
        @close="showDialog = false"
        closeOnMask
    />
  </div>
</template>

<script>
import {benefitsByNumber, benefitsSubmit, brandDropDown} from "@/api/sales";
import MessageDialog from "@/views/business/utils/messageDialog.vue";

const APPLY_TYPE = {
  EXCHANGE: '1',
  RENOVATE: '2'
};

export default {
  name: "ClubList",
  components: { MessageDialog },
  data() {
    // 手机号验证规则
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入联系电话'));
      }
      const reg = /^1[3-9]\d{9}$/;
      if (!reg.test(value)) {
        callback(new Error('请输入正确的11位手机号'));
      } else {
        callback();
      }
    };
    return {
      submitDisabled: false,
      benefitsItemList: [],
      showDialog: false,
      dialogTitle: '提示',
      messageContent: '',
      confirmText: '',
      showCancel: false,
      propNumber: '',
      title: '',
      type: '',
      // 关键修改点 3: 在 data 中添加一个变量来存储当前选中卡片的 ID
      selectedCardId: null,

      form: {
        phonenumber: '',       // 联系电话
        address: '',     // 通讯地址
        oldNumber: '',   // 球杆编号
        oldBrandCode: '',//品牌
        oldBrand: '',
        oldModelCode: '',//型号
        oldModel: '',
        newId: '',//福利id
        type: '',//类型 1、置换 2、翻新
        fileList: [],
      },


      captureType: "",
      dialogVisible: false,
      dialogImageUrl: "",

      // 新增：表单验证规则
      rules: {
        phonenumber: [
          { required: true,validator: validatePhone, trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请输入通讯地址', trigger: 'blur' }
        ],
        oldNumber: [
          { required: true, message: '球杆编码不能为空', trigger: 'blur' }
        ],
        oldBrand: [
          { required: true, message: '球杆品牌不能为空', trigger: 'blur' }
        ],
        oldModel: [
          { required: true, message: '球杆型号不能为空', trigger: 'blur' }
        ],
      },

      // 表单ref引用
      formRef: null,
      selectBrandDrop:[],
    };
  },
  watch: {
    "$route.query": {
      immediate: true,
      handler(newVal) {
        const { number, type } = newVal;
        if (!number) {
          this.$message.warning("球杆序列号不能为空");
          return;
        }
        this.propNumber = number;
        this.form.oldNumber = number.split('_')[0];
        this.fetchClubList(number.split('_')[0]);

        if (type) {
          this.type = type;
          this.title = type === APPLY_TYPE.EXCHANGE ? '置换申请' : '翻新申请';
        }
      },
    },
  },
  created() {
    this.selectBrandDropDown();
  },
  methods: {
    //查询品牌、系列数据
    async selectBrandDropDown(){
      try {
        const response = await brandDropDown();
        if(response.code===200){
          //过滤品牌
          const item = response.data.find(item => item.label === Number(this.propNumber.split('_')[1]))||[];
          if(item){
            this.form.oldBrandCode = item.label;
            this.form.oldBrand = item.value;
            if(item.children){
              //过滤型号
              const child = item.children.find(ch => ch.label === Number(this.propNumber.split('_')[2]))||[];
              if(child){
                this.form.oldModelCode = child.label;
                this.form.oldModel = child.value;
              }
            }
          }
        }
      } catch (error) {
        console.error("获取产品失败:", error);
      }
    },
    //询问框确认事件
    handleDialogConfirm(){
      this.showDialog = false;
    },
    //取消事件
    handleCancel(){
      this.showDialog = false;
    },
    // 图片上传处理
    handleFileChange(file, fileList) {
      // 1. 仅处理「文件添加」的场景（status=ready）
      if (file.status !== 'ready') {
        return; // 忽略移除/上传中的状态
      }
      // 2. 校验文件类型（和原before-upload逻辑一致）
      const isImage = file.raw.type.includes("image/"); // 注意：file.raw才是原生File对象
      if (!isImage) {
        //提示信息提示弹框组件是否显示
        this.showDialog = true;
        //显示取消按钮
        this.showCancel = false;
        //确认按钮文案
        this.confirmText = "我知道了";
        //提示信息内容
        this.messageContent = "只能上传jpg/png格式的图片！";
        // 移除错误文件（避免加入fileList）
        this.form.fileList = fileList.filter(item => item.uid !== file.uid);
        return;
      }
      // 3. 生成预览URL并更新fileList（和原逻辑一致）
      const reader = new FileReader();
      reader.readAsDataURL(file.raw);
      reader.onload = (e) => {
        this.form.fileList = Array.isArray(fileList)
            ? fileList.map(item => {
              if (item.uid === file.uid) {
                return {
                  ...item,
                  url: e.target.result,
                  raw: file.raw
                };
              }
              return item;
            })
            : [];
      };

    },
    handlePreview(file) {
      // 优先级：本地预览URL > 响应URL > 原始文件
      if (file.url) {
        this.dialogImageUrl = file.url;
      } else if (file.raw) {
        // 兼容未生成URL的情况，重新生成
        const reader = new FileReader();
        reader.readAsDataURL(file.raw);
        reader.onload = (e) => {
          this.dialogImageUrl = e.target.result;
        };
      } else {
        this.dialogImageUrl = "";
        //提示信息提示弹框组件是否显示
        this.showDialog = true;
        //显示取消按钮
        this.showCancel = false;
        //确认按钮文案
        this.confirmText = "我知道了";
        //提示信息内容
        this.messageContent = "该图片无预览地址！";
      }
      // 强制打开弹框（确保状态更新）
      this.$nextTick(() => {
        this.dialogVisible = true;
      });
    },
    // 核心修复5：图片加载失败处理
    handleImageError() {
      this.dialogImageUrl = "";
      //提示信息提示弹框组件是否显示
      this.showDialog = true;
      //显示取消按钮
      this.showCancel = false;
      //确认按钮文案
      this.confirmText = "我知道了";
      //提示信息内容
      this.messageContent = "图片预览失败，请重新上传！";
    },
    // 删除文件（确保列表同步）
    handleRemove(file, fileList) {
      this.form.fileList = [...fileList]; // 深拷贝，避免引用问题
    },
    // 超出数量提示
    handleExceed() {
      //提示信息提示弹框组件是否显示
      this.showDialog = true;
      //显示取消按钮
      this.showCancel = false;
      //确认按钮文案
      this.confirmText = "我知道了";
      //提示信息内容
      this.messageContent = `最多只能上传3张图片！`;
    },
    goHome() {
      this.$router.replace('/my_club');
    },

    async fetchClubList(number) {
      this.benefitsItemList = [];
      // 关键修改点 6: 每次获取新数据时，重置选中状态
      this.selectedCardId = null;

      try {
        const response = await benefitsByNumber(number);
        if (response.code === 200 && response.data && response.data.length > 0) {
          const propNumbers = this.propNumber.split('_');
          const targetClubId = parseInt(propNumbers[3], 10);
          const mainClubInfo = response.data.find(item => item.id === targetClubId);

          if (mainClubInfo) {
            this.benefitsItemList.push({
              id: mainClubInfo.id,
              name: mainClubInfo.name,
              equityIntro: mainClubInfo.equityIntro,
              supplement: mainClubInfo.supplement
            });

            if (this.type === APPLY_TYPE.EXCHANGE && mainClubInfo.children && mainClubInfo.children.length > 0) {
              mainClubInfo.children.forEach(child => {
                this.benefitsItemList.push({
                  id: child.relationId,
                  name: child.name,
                  equityIntro: '',
                  supplement: child.supplement
                });
              });
            }

            // 关键修改点 7: 默认选中第一个卡片（可选）
            if (this.benefitsItemList.length > 0) {
              this.selectedCardId = this.benefitsItemList[0].id;
            }

          } else {
            this.showErrorDialog('未找到指定的球杆信息。');
          }
        } else {
          this.showErrorDialog(response.returnMsg || '获取球杆权益信息失败。');
        }
      } catch (error) {
        console.error("获取球杆权益失败:", error);
        this.showErrorDialog('网络错误，获取球杆权益信息失败。');
      }
    },

    // 关键修改点 4: 定义处理卡片选中的方法
    handleCardSelect(cardId) {
      // 如果点击的是已选中的卡片，可以选择取消选中
      this.selectedCardId = this.selectedCardId === cardId ? null : cardId;
    },

    //提交申请
    async submitSelection() {
      if (!this.selectedCardId) {
        this.showErrorDialog('请选择一个球杆');
        return;
      }
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          // 表单验证通过 + 已选卡片
          if (this.selectedCardId) {
            this.submitDisabled = true;
            // 组装提交数据
            const submitData = {
              ...this.form,
              newId: this.selectedCardId,
              type: this.type
            };

            const formData = new FormData();

            formData.append('phonenumber', submitData.phonenumber);
            formData.append('address', submitData.address); // 单选值，直接传
            formData.append('oldNumber', submitData.oldNumber);
            formData.append('oldBrandCode', submitData.oldBrandCode);
            formData.append('oldBrand', submitData.oldBrand);
            formData.append('oldModelCode', submitData.oldModelCode);
            formData.append('oldModel', submitData.oldModel);
            formData.append('newId', submitData.newId);
            formData.append('type', submitData.type);

            const files = [];
            this.form.fileList.forEach(item => {
              if (item.raw) {
                files.push(item.raw);
                formData.append('file', item.raw);
              }
            });

            const res = await benefitsSubmit(formData);
            if(res.code==200){
              this.showErrorDialog("提交申请成功，请您等待售后联系！")
              this.submitDisabled = false;
                  setTimeout(() => {
                this.$router.push({
                  path: '/my_club',
                })
              }, 2000);

            }else{
              this.submitDisabled = false;
              this.showErrorDialog(res.returnMsg)
            }
          } else {
            this.showErrorDialog('请选择一个球杆');
          }
        }
      });
    },

    showErrorDialog(message) {
      this.showDialog = true;
      this.showCancel = false;
      this.confirmText = "我知道了";
      this.messageContent = message;
    }
  },
};
</script>

<style lang="scss" scoped>
// 页面整体容器
.club-list-container {
  width: 100%;
  background-color: #f9f9f9;
  min-height: 100vh;

  .container {
    width: 100%;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    max-height: 70vh;
    height: 70vh;

    // 顶部区域
    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 15px;
      background: #f6c27a;
    }

    // 顶部标题
    .title {
      text-align: center;
      flex-grow: 1;
      line-height: 60px;
      font-size: 16px;
      color: #161616;
      letter-spacing: 1px;
      font-weight: bold;
      margin: 0;
    }
    .desc{
      font-size: 12px;
      padding: 10px 10px 0 10px;
      color: #e53935
    }

    // 卡片列表容器
    .card-list {
      width: 100%;
      margin: 0;
      padding: 20px;
    }

    // 每个卡片的容器
    .card-container {
      margin-bottom: 20px;
    }
    .club-card {
      cursor: pointer; // 添加手型光标，提示可点击
      transition: all 0.3s ease;
      position: relative;

      // 当 .club-card 拥有 .is-selected 类时，应用以下样式
      &.is-selected {
        border-color: #409EFF; // Element UI 主题色
        box-shadow: 0 0 12px rgba(64, 158, 255, 0.3);

        // 使用 ::v-deep 穿透 scoped 限制，修改 el-card 内部元素的样式
        ::v-deep .el-card__body {
          background-color: #f0f7ff; // 选中时背景色
        }
      }
    }
    .checkmark-container {
      position: absolute;
      top: -10px;
      right: -10px;
      width: 24px;
      height: 24px;
      background-color: #67c23a; /* Element UI 成功色 */
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: white;
      font-size: 14px;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
      z-index: 10; /* 确保在卡片阴影之上 */
    }


    // 卡片主体
    .card-body {
      flex-grow: 1;
      padding: 20px;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    // 信息项样式
    .info-item {
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      font-size: 15px;

      &:last-child {
        margin-bottom: 0;
      }

      .label {
        font-weight: bold;
        color: #555;
        width: 180px; // <-- 使用固定宽度
        text-align-last: justify; // <-- 核心：实现两端对齐
      }


      .value {
        color: #333;
        word-break: break-all;
        padding-left: 20px; // 增加一点与label的间距
      }
    }

    // 跨色换补差表格容器
    .cross-color-table-container {
      margin-top: 15px; // 与上方信息项保持间距
      ::v-deep .el-table__row{
        height: 20px !important;
      }
    }

    // 空状态提示
    .empty-state {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 400px;
      background-color: #fff;
      border-radius: 8px;
      margin: 20px;
    }
    .btn-group,
    .btn-group-back {
      display: flex;
      justify-content: center;
      gap: 15px;
      margin: 20px 0;
    }

    // 页脚
    .footer {
      height: 50px;
      background: #2c2c2c;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 20px;
      box-sizing: border-box;

      p {
        color: #ea9538;
        font-size: 10px;
        font-weight: bold;
        letter-spacing: 1px;
        margin: 0;
      }
    }

    .form-container {
      padding: 20px;
      background: #fff;
      border-radius: 10px;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);

      .club-form {
        width: 100%;
        padding: 0 30px;
      }

      ::v-deep .el-form-item {
        background: #FFFFFF;
        height: auto;
        padding: 0 10px;
        //margin-bottom: 30px;
        display: flex;
        align-items: center;
      }

      ::v-deep .el-form-item__label {
        font-weight: 500;
        text-align: left !important;
        line-height: normal;
      }

      ::v-deep .el-form-item__content {
        flex: 1;
        line-height: normal;
        padding-left: 10px;
        margin-left: 0 !important;
      }
      // 上传组件通用样式（单列）
      .avatar-uploader {
        ::v-deep .el-upload--picture-card {
          position: relative;
        }
      }

      ::v-deep .el-upload-list--picture-card {
        ::v-deep .el-upload-list__item {
          position: relative;
          margin-right: 10px;
          margin-bottom: 10px;
          width: 100px !important;
          height: 100px !important;
        }

        ::v-deep .el-upload-list__item-thumbnail {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        ::v-deep .el-upload-list__item-delete,
        ::v-deep .el-upload-list__item-preview {
          border-radius: 50%;
          background: rgba(0,0,0,0.5);
          color: #fff !important;
          text-align: center;
        }

        ::v-deep .el-upload-list__item:hover .el-upload-list__item-delete,
        ::v-deep .el-upload-list__item:hover .el-upload-list__item-preview {
          background: rgba(0,0,0,0.7);
        }
      }

    }



  }

  // ===================== 移动端适配（<768px） =====================
  @media screen and (max-width: 767px) {
    .container {
      .header {
        padding: 0 10px;
      }
      .title {
        font-size: 16px;
        line-height: 60px;
      }
      .desc {
        font-size: 12px;
        padding: 10px 10px 0 10px;
      }
      .card-list {
        padding: 10px;
      }
      .club-card {
        border-radius: 10px;
      }
      .checkmark-container {
        top: 10px;
        right: 10px;
        width: 14px;
        height: 14px;
        border-radius: 50%;
        font-size: 14px;
      }
      .info-item {
        font-size: 14px;
        .label {
          width: 80px;
          font-weight: 500;
        }
        .value {
          padding-left: 10px;
          width: 300px;
        }
      }
      .cross-color-table-container {
        ::v-deep .el-table__row{
          height: 20px !important;
          font-size: 14px;
        }
        ::v-deep .el-table__cell{
          height: 20px !important;
          font-size: 14px;
        }
        ::v-deep .el-table__cell .cell{
          color: #333;
          height: 20px;
          font-size: 14px;
          line-height: 20px;
        }
        ::v-deep .el-table td.el-table__cell div{
          line-height: 20px !important;
        }
      }
      .empty-state {
        margin: 10px;
        height: 300px;
      }
      .el-button--default{
        font-size: 20px;
        color: #0f0f0f;
        background: #dcdcdc;
        border: none;
        width: 80%;
        border-radius: 3px;
      }
      .el-button--primary{
        font-size: 20px;
        color: #0f0f0f;
        background: #f6c27a;
        border: none;
        width: 80%;
        border-radius: 3px;
      }
      .btn-group,
      .btn-group-back {
        display: flex;
        justify-content: center;
        gap: 15px;
        height: 40px;
        line-height: 40px;
        margin: 20px 0 20px 0;
      }
      .footer {
        height: 50px;
        margin-top: 15px;
        p {
          font-size: 9px;
          padding: 0 10px;
          text-align: center;
        }
      }

      .form-container {
        padding: 15px;
        border-radius: 10px;
        ::v-deep .el-form-item {
          padding-bottom: 15px;
        }
        ::v-deep .el-form-item__label {
          font-size: 14px;
          font-weight: 500;
          text-align: left !important;
          line-height: 30px;
          width: 70px !important;
        }
        ::v-deep .el-form-item__content {
          flex: 1;
          line-height: normal;
          //padding-left: 10px;
          margin-left: 0 !important;
        }

        ::v-deep .el-input__inner,
        ::v-deep .el-textarea__inner {
          font-size: 14px;
          padding: 8px 10px;
          height: 30px !important;
        }
        ::v-deep .el-form-item__error {
          font-size: 10px;
          padding-top: 2px;
          padding-left: 10px;
        }

        .upload-tip {
          font-size: 10px;
          color: #999;
          margin-top: 5px;
        }
        // 上传卡片/缩略图基础样式
        .avatar-uploader {
          ::v-deep .el-upload--picture-card {
            width: 100px !important;
            height: 100px !important;
            line-height: 100px !important;
            font-size: 20px !important;
          }
        }
        ::v-deep .el-upload-list--picture-card {
          .el-upload-list__item {
            width: 100px !important;
            height: 100px !important;
            margin-right: 10px !important;
            margin-bottom: 10px !important;
            position: relative; // 确保子元素绝对定位生效
          }
          // 已上传图片预览图适配
          .el-upload-list__item-thumbnail {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }

          // 1. 删除按钮样式（基准）
           .el-upload-list__item-delete {
            font-size: 16px !important; // 按钮大小
            top: 5px !important;        // 垂直位置
            right: 5px !important;      // 水平位置
            width: 20px !important;     // 点击区域大小
            height: 20px !important;
            line-height: 20px !important;
            border-radius: 50%; // 圆形背景（可选，和预览按钮统一）
            background: rgba(0,0,0,0.5); // 半透明背景
            color: #fff !important;
            text-align: center;
          }

          // 2. 预览按钮样式（和删除按钮完全统一）
           .el-upload-list__item-preview {
            font-size: 16px !important; // 和删除按钮同大小
            top: 5px !important;        // 和删除按钮同垂直位置
            right: 30px !important;     // 位于删除按钮左侧，间距合理
            width: 20px !important;     // 点击区域和删除按钮一致
            height: 20px !important;
            line-height: 20px !important;
            border-radius: 50%; // 圆形背景，和删除按钮统一
            background: rgba(0,0,0,0.5); // 半透明背景
            color: #fff !important;
            text-align: center;
            // 预览图标居中
            ::v-deep .el-icon-zoom-in {
              font-size: 14px !important; // 图标略小于按钮，视觉更协调
              line-height: 20px !important;
            }
          }

          // 鼠标悬浮效果（可选，增强交互）
          .el-upload-list__item:hover .el-upload-list__item-delete,
          .el-upload-list__item:hover .el-upload-list__item-preview {
            background: rgba(0,0,0,0.7);
          }

        }
      }


    }
  }

  // ===================== 平板和PC端适配（≥768px） =====================
  @media screen and (min-width: 768px) {
    .container {
      .card-list-wrapper {
        max-width: 700px; // 平板和PC端可以适当放宽
      }
      .info-item {
        font-size: 16px;
        .label {
          width: 120px;
        }
        .value {
          padding-left: 20px;
        }
      }
      .empty-state {
        max-width: 700px;
        margin: 20px auto;
      }
      .footer {
        height: 55px;
        margin-top: 25px;
        p {
          font-size: 11px;
        }
      }
    }
  }
}
</style>